module.exports = __webpack_public_path__ + "img/reset-password-v2.8c8c844d.svg";